module.exports = __webpack_public_path__ + "static/media/pre-selection-banner.b1eedd35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pre-selection-banner.png
// module id = 2611
// module chunks = 1